import { createSelector } from 'reselect';

const isStageAdvancing = createSelector(
  (state, journeyId) => state.journeyStops[journeyId],
  (_, __, stopId) => stopId,
  (_, __, ___, stage) => stage,
  (journeyInfo, savedStopId, savedStage) => {
    if (!journeyInfo || !(journeyInfo || {}).advancing) {
      return false;
    }

    const { stopId, stage } = journeyInfo.advancing;

    return savedStopId === stopId && savedStage === stage;
  }
);

const isStageOpened = createSelector(
  (state, journeyId) => state.journeyStops[journeyId],
  (_, __, stopId) => stopId,
  (_, __, ___, stage) => stage,
  (journeyInfo, savedStopId, savedStage) => {
    if (!journeyInfo || !(journeyInfo || {}).opened) {
      return false;
    }

    const { stopId, stage } = journeyInfo.opened;

    return savedStopId === stopId && savedStage === stage;
  }
);

const getETAerror = createSelector(
  (state, journeyId) => state.journeyStops[journeyId],
  (journeyInfo) => {
    if (!journeyInfo) {
      return false;
    }
    return journeyInfo.accuracyError;
  }
);

const getETAData = createSelector(
  (state, journeyId) => state.journeyStops[journeyId],
  (journeyInfo) => {
    if (!journeyInfo) {
      return false;
    }
    return journeyInfo.ETAData ? journeyInfo.ETAData : false;
  }
);

export { isStageAdvancing, getETAerror, getETAData, isStageOpened };
